import { useCallback, useSyncExternalStore } from 'react';
import { CLEARANCE_EVENT, CLEARANCE_STORAGE_KEY } from '@/app/lib/constants';

function subscribe(onStoreChange: () => void) {
  window.addEventListener('storage', onStoreChange);
  window.addEventListener(CLEARANCE_EVENT, onStoreChange);
  return () => {
    window.removeEventListener('storage', onStoreChange);
    window.removeEventListener(CLEARANCE_EVENT, onStoreChange);
  };
}

function readClearance() {
  try {
    return window.localStorage.getItem(CLEARANCE_STORAGE_KEY) === 'granted';
  } catch {
    return false;
  }
}

const serverClearance = () => false;

export function useClearance() {
  const hasClearance = useSyncExternalStore(subscribe, readClearance, serverClearance);

  const grantClearance = useCallback(() => {
    window.localStorage.setItem(CLEARANCE_STORAGE_KEY, 'granted');
    window.dispatchEvent(new Event(CLEARANCE_EVENT));
  }, []);

  const revokeClearance = useCallback(() => {
    window.localStorage.removeItem(CLEARANCE_STORAGE_KEY);
    window.dispatchEvent(new Event(CLEARANCE_EVENT));
  }, []);

  return { hasClearance, grantClearance, revokeClearance };
}
